export default {
  locale: {
    zhHans: '簡體',
    zhHant: '繁體'
  },
  index: {
    home: '首頁',
    vote: '問卷調查',
    comment: '跟帖',
    me: '我的',
    personal: '我的信息',
    changePwd: '修改密碼',
    collection: '收藏',
    notice: '通知',
    history: '歷史',
    life: '商家',
    addlife: '商家發佈',
    myaddlife: '我發佈的商家信息',
    viewlife: '商家信息詳情',
    recruit: '招聘',
    addrecruit: '發佈招聘',
    myaddrecruit: '我發佈的招聘',
    viewrecruit: '招聘詳情',
    youknow: '易書',
    addyouknow: '發佈易書',
    myaddyouknow: '我發佈的易書',
    viewyouknow: '易書詳情',
    commentonmy: '評論我的',
    praiseme: '點讚我的',
    icommented: '我評論的',
    ilikeit: '我點讚的',
    search: '搜索',
    languageChangeConfirm: '此設置將重新啟動應用!'
  },
  common: {
    morelist: '上拉加載更多',
    loading: '加載中',
    baseline: '我是有底線的',
    totop: '置頂',
    adv: '廣告',
    nodata: '暫無數據'
  },
  home: {
    allcomments: '全部評論',
    nocomments: '目前還沒有跟貼，歡迎您發表觀點',
    reply: '回覆: 說說你的見解'
  },
  form: {
    title: '標題',
    titleInput: '請輸入標題',
    column: '所屬類別',
    columnInput: '請選擇所屬類別',
    area: '所在城市',
    areaInput: '請選擇地區',
    contact: '聯繫人',
    contactInput: '請輸入聯繫人',
    phone: '聯繫電話',
    phoneInput: '請輸入聯繫電話',
    EmailInput: '請輸入Email',
    content: '內容描述',
    contentInput: '請輸入內容描述',
    uploadImg: '圖片',
    uploadImgUp: '請上傳圖片',
    okbutton: '確 定',
    okbutton2: '立即發佈',
    addsuccess: '發佈成功',
    editsuccess: '修改成功',
    wanttorecruit: '我要招聘',
    recruitposition: '請輸入招聘崗位',
    salary: '薪資',
    salaryType: '薪資類別',
    entersalary: '請輸入薪資',
    Industry: '所屬行業',
    selectindustry: '請選擇所屬行業',
    education: '學歷',
    selectdegree: '請選擇學歷',
    experience: '工作經驗',
    selectexperience: '請選擇工作經驗',
    region: '所屬地區',
    selectregion: '請選擇所屬地區',
    workplace: '工作地點',
    enterplace: '請輸入工作地點',
    numberrecruiters: '招聘人數',
    enternumberrecruiters: '請輸入招聘人數',
    recruitmentType: '招聘類型',
    selectrecruittype: '請選擇招聘類型',
    positionDescription: '職位描述',
    enterjobdescription: '請輸入職位描述',
    benefits: '福利待遇',
    enterbenefits: '請輸入福利待遇',
    companyname: '公司名稱',
    entercompanyname: '請輸入公司名稱',
    companyProfile: '公司簡介',
    entercompanyprofile: '請輸入公司簡介',
    unlimited: '不限',
    fulltime: '全職',
    parttime: '兼職',
    Internship: '實習',
    region2: '地區',
    category: '類別',
    All: '全部',
    time: '時間',
    '3daysago': '3天前',
    '7daysago': '7天前',
    '1monthago': '1個月前',
    longago: '很久以前',
    browse: '瀏覽',
    like: '點讚',
    comment: '評論',
    release: '發佈',
    offshelf: '已下架',
    indisplay: '顯示中',
    operation: '操作',
    putshelf: '上架',
    modify: '修改',
    details: '詳情',
    delete: '刪除',
    remove: '下架',
    weiguan: '人圍觀',
    positionDetails: '職位詳情',
    popularPosition: '熱門職位',
    applyPosition: '申請職位',
    source: '來源'
  },
  login: {
    inputpassword: '請輸入密碼',
    forgotpassword: '忘記密碼',
    enteremail: '請輸入郵箱',
    entervercode: '請輸入郵箱驗證碼',
    newpassword: '請輸入新的登錄密碼',
    submit: '提交',
    sendvercode: '發送驗證碼',
    sentEmailsuccess: '郵箱驗證碼發送成功',
    resend: '重新發送',
    enteremailaddress: '請輸入郵箱地址',
    enternewpassword: '請輸入新密碼',
    tologinpage: '修改成功即將跳轉到登錄頁',
    mailboxnotempty: '郵箱不能為空',
    formatincorrect: '郵箱格式不正確',
    skip: '跳過',
    accountLogin: '賬號登錄',
    enterloginpassword: '請輸入登錄密碼',
    loginnow: '立即登錄',
    registerNow: '立即註冊',
    register: '註冊',
    enternickname: '請輸入暱稱',
    selectgender: '請選擇性別',
    viewandagree: '查看並同意',
    termsofUse: '使用條款',
    privacyPolicy: '隱私政策',
    existAccount: '已有賬號',
    directLogin: '直接登錄',
    successregistered: '註冊成功，即將跳轉到登錄頁',
    check: '請勾選查看並同意《使用條款》《隱私政策》！'
  },
  me: {
    integral: '積分',
    platform: '商家、招聘、易書等信息交流平台',
    commonfunctions: '常用功能',
    message: '消息',
    basicInfo: '基本信息',
    ersiovnUpdate: '版本更新',
    ersiovns: '版本號',
    logout: '退出登錄',
    accountCancellate: '註銷賬戶',
    publishedItems: '選擇發佈的項目',
    cancellationSucceeded: '賬戶註銷成功',
    originalPassword: '原密碼',
    newPassword: '新密碼',
    InputoriginalPassword: '請輸入原密碼',
    InputnewPassword: '請輸入新密碼',
    confirmPassword: '確認密碼',
    enterNewPasswordAgain: '請再次輸入新密碼',
    enterConfirmationPassword: '請輸入確認密碼',
    modify: '確定要修改嗎?',
    systemPrompt: '系統提示',
    logInAgain: '密碼修改成功，請重新登錄！',
    enteredInconsistent: '兩次密碼輸入不一致！',
    changeAvatar: '點擊更換頭像',
    support: '單張圖片最大支持5MB',
    operationSucceeded: '操作成功',
    operationFailed: '操作失敗',
    tel: '手機號碼',
    inputTel: '請輸入手機號碼',
    emial: '郵箱',
    nickname: '請輸入暱稱',
    gender: '性別',
    birthday: '生日',
    selectBirthday: '請選擇生日',
    login: '登錄',
    likeArticle: '文章讚',
    likeComments: '評論讚',
    keywords: '請輸入搜索關鍵詞',
    news: '新聞',
    selectCity: '請選擇所在城市',
    reply: '回覆',
    expand: '展開',
    replies: '條回覆',
    popularComments: '熱門評論',
    seemore: '點擊查看更多',
    comment: '目前還沒有跟貼，歡迎您發表觀點',
    dial: '撥打',
    body: '正文',
    Likeit: '點讚成功',
    cancelLiking: '取消點讚',
    send: '發送',
    commentScuess: '評論成功',
    uploading: '上傳中',
    inputing: '開始輸入...',
    uploading2: '上傳中...',
    uploading3: '正在上傳中...'
  },
  plugn: {
    selectphoto: '選照片',
    deleteit: '確定刪除嗎?'
  },
  upload: {
    name: '點擊上傳',
    drag: '將文件拖到此處，或',
    file: '上傳圖片',
    valid: '選擇的文件格式不符合要求',
    limited: '當前限制選擇',
    files: '個文件，本次選擇了',
    allSelected: '個文件，共選擇了',
    aFile: '個文件',
    restored: '確定移除嗎？一旦刪除，將無法恢復！',
    verify: '確認',
    cancel: '取消'
  },
  views: {
    titles: '廣告詳情',
    fan: '關註/粉絲數據',
    followed: '已關註',
    followStatus: '關註',
    unfollow: '確認不再關註',
    confirm: '確認關註?',
    successfully: '取消關註成功',
    focus: '關註成功',
    saved: '你收藏了該文章',
    zan: '你贊了該文章',
    zanArc: '你贊了該評論',
    fans: '粉絲',
    follow: '關註',
    liked: '贊過',
    likes: '獲贊',
    comments: '我的評論',
    received: '收到的評論',
    history: '瀏覽記錄',
    account: '賬戶設置',
    male: '男',
    female: '女',
    Preview: '預覽',
    Circular: '圓形預覽',
    available: '暫無預覽',
    Square: '方形預覽',
    update: '重新選擇',
    format: '更新預覽',
    uploaded: '圖片格式錯誤！請選擇 jpg、png、gif 格式的圖片',
    exceed: '上傳圖片大小不能超過 5MB!',
    successful: '頭像上傳成功',
    failed: '頭像上傳失敗: ',
    avatar: '裁剪頭像',
    ok: '確定',
    published: '發布於',
    createbook: '發布易書筆記',
    editbook: '編輯易書筆記',
    detailbook: '易書筆記詳情',
    contentPlaceholder: '請輸入內容',
    imageUploading: '圖片上傳中...',
    imageUploadSuccess: '圖片上傳成功',
    imageUploadFailed: '圖片上傳失敗：',
    imageTypeLimit: '只能上傳圖片文件',
    resetForm: '重置',
    newPublish: '新發布',
    threeDaysAgo: '3天內',
    sevenDaysAgo: '7天內',
    oneMonthAgo: '1個月內',
    longTimeAgo: '很久以前',
    bookList: '易書筆記列表',
    publishTime: '發布時間',
    statistics: '統計數據',
    confirmOffShelf: '確定要下架該商家嗎？',
    youknowTip: '提示',
    confirmOnShelf: '確定要上架該商家嗎？',
    onShelfSuccess: '上架成功',
    offShelfSuccess: '下架成功',
    confirmDelete: '確定要刪除該商家嗎？',
    deleteSuccess: '刪除成功',
    imageLoading: '圖片加載中...',
    cancelFollow: '取消關註',
    createadv: '發布商家廣告',
    editadv: '編輯商家廣告',
    detailadv: '商家廣告詳情',
    createmer: '發布招聘',
    updatemer: '編輯招聘',
    detailmer: '招聘詳情',
    salary: '月薪',
    hourly: '時薪',
    recruitment: '招聘詳情',
    occupation: '職業類型',
    allArea: '全部地區',
    months: '元/月',
    hours: '元/時',
    advertising: '廣告',
    favorited: '已收藏',
    address: '工作地址',
    poster: '職位發布人',
    collected: '收藏成功',
    unsave: '取消收藏',
    merchant: '商家廣告列表',
    recruitment: '招聘列表',
    category: '所屬欄目',
    jobtype: '工作類型',
    guess: '猜你喜歡',
    featured: '熱點精選',
    more: '更多',
    trading: '物品買賣',
    Latest: '最新新聞',
    immigration: '移民要聞',
    easyBooks: '熱門易書',
    realEstate: '地產頭條',
    finance: '財經資訊',
    jobHunting: '求職招聘',
    automotive: '汽車專題',
    interesting: '奇聞趣事',
    survey: '問卷調查',
    participants: '已有',
    peopleJoined: '人參與',
    getInfo: '獲取信息',
    easierHere: '從這裏更容易',
    welcomeLogin: '歡迎登錄',
    loginBetter: '登錄後內容更精彩',
    welcomeRegister: '歡迎註冊',
    agreeRead: '我已經閱讀並同意',
    userAgreement: '《用戶協議》及《隱私條款》',
    passwordMismatch: '兩個密碼不一致',
    passwordLength: '密碼長度在6到16個字符之間',
    sending: '發送中，請稍後...',
    searchNow: '立即搜索',
    searchFound: '共搜索到',
    relatedTo: '條與',
    pwd: '密碼',
    vers: '驗證碼',
    newPwd: '請再次輸入密碼',
    nickname: '昵稱',
    keys: '請輸入關鍵詞',
    infos: '相關的信息',
    aboutUs: '關於我們',
    serviceAgreement: '服務協議',
    adPlacement: '廣告投放',
    clientDownload: '客戶端下載',
    companyAddress: '公司地址',
    richmondHQ: '列治文總部',
    contactUs: '聯系我們',
    businessCooperation: '商務合作',
    officialWebsite: '知易官網',
    shareTo: '分享到',
    weibo: '微博',
    qqZone: 'QQ空間',
    wechat: '微信',
    copyLink: '復製鏈接',
    cancel: '取消',
    wechatShare: '微信分享',
    scanQRCode: '請使用微信掃描二維碼分享',
    commentsCount: '條評論',
    pleaseLoginFirst: '請先',
    afterLoginComment: '後再發表評論',
    commentNow: '立即評論',
    commentPlaceholder: '請輸入您的評論...',
    noComments: '暫無評論',
    publishReply: '發布回復',
    linkCopied: '鏈接已復製到剪貼板',
    pleaseLogin: '請先登錄',
    replyNotEmpty: '回復內容不能為空',
    replySuccess: '回復成功',
    replyFailed: '回復失敗',
    cannotLikeAndDislike: '您不能同時對一篇文章又贊又踩哦',
    commentNotEmpty: '評論內容不能為空',
    commentFailed: '評論失敗',
    delFailed: '刪除失敗',
    submitFailed: '確定要取消回復嗎？內容將不會被保存。',
    copyFailed: '復製失敗，請手動復製',
    interest: '搜索感興趣的內容',
    release: '發布中心',
    menuItem: '互動消息',
    settingOption: '賬號設置',
    actionButton: '更換密碼',
    zhCN: '中文簡體',
    zhTW: '中文繁體',
    outlogin: '確定要退出登錄嗎?',
    personal: '個人中心',
    merchantAds: '商家廣告',
    adsList: '廣告列表',
    publishAd: '發布廣告',
    recruitmentInfo: '招聘信息',
    readingNotes: '易書筆記',
    notesList: '筆記列表',
    publishNote: '發布筆記',
    columnpublish: '請選擇發布的欄目',
    housekeeping: '家政、裝修、維修、搬運、二手、租房、賣房、租車、律師、教培、移民等',
    finance2: 'IT、金融、房地產、建築、貿易、零售、物流、教育、傳媒、服務業、市場等',
    exploration: '美食探店、美妝護膚、旅行、家居生活、情感、心理、職場、學習等',
    ranking: '熱點排行',
    centers: '發布中心',
  }
}


// WEBPACK FOOTER //
// ./src/lang/zh-TW.js